<!-- To make easy use of the "last-of-typ"-css selector we need that group-component -.- -->
<div class="avano-button-bar-all-groups">
  <ng-container *ngIf="buttonsData | avanoButtonBarButtonGroup: buttonGroup.PRIMARY as primaryBtns">
    <div class="avano-button-bar-group" *ngIf="primaryBtns.length">
      <avano-button-bar-button *ngFor="let buttonDetails of primaryBtns" [buttonDetails]="buttonDetails"></avano-button-bar-button>
    </div>
  </ng-container>

  <ng-container *ngIf="buttonsData | avanoButtonBarButtonGroup: buttonGroup.SECONDARY as secondaryBtns">
    <div class="avano-button-bar-group" *ngIf="secondaryBtns.length">
      <avano-button-bar-button *ngFor="let buttonDetails of secondaryBtns" [buttonDetails]="buttonDetails"></avano-button-bar-button>
    </div>
  </ng-container>

  <ng-container *ngIf="buttonsData | avanoButtonBarButtonGroup: buttonGroup.TERTIARY as tertiaryBtns">
    <div class="avano-button-bar-group" *ngIf="tertiaryBtns.length">
      <avano-button-bar-button *ngFor="let buttonDetails of tertiaryBtns" [buttonDetails]="buttonDetails"></avano-button-bar-button>
    </div>
  </ng-container>
</div>

<!-- Expand/Collapse all -->
<avano-button-bar-collapse-expand-all *ngIf="enableExpandCollapse"></avano-button-bar-collapse-expand-all>

<!-- Help button-->
<div class="avano-button-bar-help-container" *ngIf="enableHelp">
  <avano-button-bar-help (click)="requestHelp()"></avano-button-bar-help>
</div>
